

class Mutex {
    constructor() {
      this.locked = false;
      this.queue = [];
    }
  
    async acquire() {
      const acquireLock = () => new Promise(resolve => this.queue.push(resolve));
  
      while (this.locked) {
        await acquireLock();
      }
  
      this.locked = true;
    }
  
    release() {
      while (this.queue.length > 0) {
        const next = this.queue.shift();
        next();
      }
      this.locked = false;
      
    }

    isLocked(){
      return this.locked
    }

    queueLength(){
      return this.queue.length
    }
}
 
export default Mutex;
  
  